/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Subject_HintInputs */

const cs_gdpr_subject_hint = /** @type {(inputs: Gdpr_Subject_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najděte klienta, poptávku nebo uživatele podle jména, e-mailu či telefonu. Vidíte jen data své kanceláře.`)
};

const en_gdpr_subject_hint = /** @type {(inputs: Gdpr_Subject_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a client, lead or user by name, e-mail or phone. You only see your own office's data.`)
};

/**
* | output |
* | --- |
* | "Find a client, lead or user by name, e-mail or phone. You only see your own office's data." |
*
* @param {Gdpr_Subject_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_subject_hint = /** @type {((inputs?: Gdpr_Subject_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Subject_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_subject_hint(inputs)
	return cs_gdpr_subject_hint(inputs)
});